export const BackOfficeEnum = [
  { value: "BPO", label: "BPO Consig" },
  { value: "FUNCAO", label: "Função" },
  { value: "BMP", label: "BMP" },
]